module.exports = __webpack_public_path__ + "static/media/ic_papper-check.84a9c079.svg";